module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "gicdungri.d68650bb.webp";